/*eslint no-array-constructor: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/

import withValidarRecuperar from 'HOC/withValidarRecuperar';
import { ApiKeyFetch } from 'api/fetchers/apiKey';
import BreadCurmb from 'components/BreadCrumbMex/BreadCrumb';
import BreadCrumbPasosV2 from 'components/BreadCrumbMex/BreadCrumbPasosV2';
import BreadCurmbPasos from 'components/BreadCrumbMex/BreadCrumbTipo2';
import DynamicForm from 'components/DynamicForm';
import ModalContratante from 'components/ModalMex/ModalContratante';
import Page from 'components/Page';
import EmisionFooterBarButtons from 'components/Polizas/EmisionFooterBarButtons';
import FormContratanteAsegurado from 'components/Polizas/FormContratanteAsegurado';
import { URLS_PHP_8 } from 'constants/urls_v2';
import { useNavbarContext } from 'contexts/NavbarContext';
import useBuscarColonias from 'hooks/useBuscarColonias';
import useBuscarMunicipios from 'hooks/useBuscarMunicipios';
import useCustomForm from 'hooks/useCustomForm';
import useCustomToast from 'hooks/useCustomToasts';
import React, { useCallback, useEffect, useState } from 'react';
import { FormProvider } from 'react-hook-form';
import { PASOS_BREADCRUMBS } from 'utils/constants';
import PRODUCTOS from 'utils/constants/PRODUCTOS';
import { isArray, mapArrayDropdownOptions } from 'utils/funciones';
import Loading from 'wrappers/Loading';

const API = ApiKeyFetch.instance();

const ContainerEmisionContratante = ({ qParams, history }) => {
  const { idPoliza, codProducto } = qParams;

  const methods = useCustomForm({ mode: 'onChange' });
  const { addWarningToast, addSuccessToast } = useCustomToast();
  const [catalogo, setCatalogo] = useState(null);
  const [loading, setLoading] = useState(true);

  const municipiosHook = useBuscarMunicipios();
  const { setMunicipios } = municipiosHook;
  const coloniasHook = useBuscarColonias();
  const { setColonias } = coloniasHook;

  const [routes, setRoutes] = useState({});

  const { setProductoActivo } = useNavbarContext();
  const init = useCallback(async () => {
    setLoading(true);
    setProductoActivo(codProducto);

    const Body = {
      polCodigo: idPoliza,
      prodCodigo: codProducto,
      pasoRevContratante: 'obtenerContratante',
      pasoCatContratante: 'catalogoContratante',
      formulario: 'contratante',
    };

    const res = await API.post(URLS_PHP_8.emision.seccionCargaContratante, Body);
    console.log('RES---: ', res, Body);

    if (res?.transaccion && res?.data) {
      const { municipios, colonias, catalogo } = res?.data;
      console.log(catalogo);
      if (!catalogo?.camposAdicionales?.permitirEmitir) {
        addWarningToast('No se puede emitir esta póliza', {
          autoDismiss: false,
        });
      }

      if (catalogo?.DatosContratanteAsegurado) {
        methods.reset({
          ...catalogo.DatosContratanteAsegurado,
        });
        if (isArray(municipios)) {
          setMunicipios(municipios?.map(mapArrayDropdownOptions));
        }
        if (isArray(colonias)) {
          setColonias(colonias?.map(mapArrayDropdownOptions));
        }
      }
      setRoutes(catalogo?.pasosRedireccionamiento);
      setCatalogo(catalogo);
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    init();
  }, [init]);

  const guardarInformacion = async (data, guardarDatos = true) => {
    setLoading(true);
    const Data = {
      prodCodigo: codProducto,
      idPoliza,
      guardarDatos,
      datosContratanteAsegurado: data,
    };

    const res = await API.post(URLS_PHP_8.emision.guardarContratante, Data);
    console.log('RES: ', res);
    if (res.transaccion) {
      if (guardarDatos === false) {
        const route = routes.find((e) => e.codigo === 'contratante');
        return history.push(`${route.goTo}`);
      }
      addSuccessToast('Se ha guardado la información de forma correcta');
    } else {
      addWarningToast('Ha ocurrido un problema al momento de guardar el contratante');
    }
    setLoading(false);
    init();
  };

  const onSubmit = async (data) => {
    await guardarInformacion(data, false);
  };

  const onClickAtras = () => {
    const route = routes.find((e) => e.codigo === 'contratante');
    history.push(`${route.goBack}`);
  };

  const onGuardar = async () => {
    const isValid = await methods.trigger('tipoPersona');
    if (isValid) {
      const data = methods.getValues();
      await guardarInformacion(data);
    } else {
      addWarningToast('Debe seleccionar un tipo de persona');
    }
  };

  const onSubmitError = () => {
    addWarningToast('Rellene el formulario correctamente');
  };

  return (
    <React.Fragment>
      <Loading loading={loading}>
        {catalogo?.DatosContratanteAsegurado && <ModalContratante catalogo={catalogo} />}
        <div className="cr-content">
          <FormProvider {...methods}>
            <form>
              <Page styles={{ minHeight: '80vh' }}>
                {codProducto !== 'AUTO' && <BreadCurmb {...PASOS_BREADCRUMBS[codProducto].breadCrumb} />}
                {codProducto === 'AUTO' && (
                  <BreadCurmb {...PASOS_BREADCRUMBS[codProducto].breadCrumbPasos[5].breadCrumb} />
                )}

                {![PRODUCTOS.APINDIVIDUAL].includes(codProducto) && (
                  <BreadCurmbPasos {...PASOS_BREADCRUMBS[codProducto].breadCrumbPasos[5]} />
                )}

                {[PRODUCTOS.APINDIVIDUAL].includes(codProducto) && (
                  <BreadCrumbPasosV2
                    {...PASOS_BREADCRUMBS[PRODUCTOS.APINDIVIDUAL].breadCrumbPasosCotizacion[4]}
                    pasos={PASOS_BREADCRUMBS[PRODUCTOS.APINDIVIDUAL]?.pasosCotizacion}
                  />
                )}

                {![PRODUCTOS.AUTO, PRODUCTOS.APINDIVIDUAL].includes(codProducto) && (
                  <FormContratanteAsegurado
                    title="Contratante"
                    formulario="contratante"
                    catalogo={catalogo}
                    onClickAtras={onClickAtras}
                    onSubmit={onSubmit}
                    onGuardar={onGuardar}
                    {...{
                      ...municipiosHook,
                      ...coloniasHook,
                    }}
                  />
                )}

                {[PRODUCTOS.AUTO, PRODUCTOS.APINDIVIDUAL].includes(codProducto) && (
                  <React.Fragment>
                    <DynamicForm {...catalogo?.validaciones} resources={catalogo} />
                  </React.Fragment>
                )}
              </Page>
            </form>
          </FormProvider>

          <EmisionFooterBarButtons
            showAtras={[PRODUCTOS.AUTO, PRODUCTOS.APINDIVIDUAL].includes(codProducto)}
            onClickAtras={onClickAtras}
            onClickGuardar={onGuardar}
            onClickContinuar={methods.handleSubmit(onSubmit, onSubmitError)}
          />
        </div>
      </Loading>
    </React.Fragment>
  );
};

export default withValidarRecuperar(ContainerEmisionContratante);
